<template>
  <div id="centerRight2" style="position: relative; overflow: hidden;">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="align-left" class="text-icon"></icon>
        </span>
        <span class="fs-xl text mx-2">健康档案人数</span>
      </div>
      <div class="d-flex ai-center flex-column body-box">
        <dv-capsule-chart class="dv-cap-chart" :config="config" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      config: {
        data: [
          {
            name: '兴安街道',
            value: 5000
          },
          {
            name: '新安街道',
            value: 4500
          },
          {
            name: '凌河街道',
            value: 4000
          },
          {
            name: '景芝镇',
            value: 3500
          },
          {
            name: '官庄镇',
            value: 3000
          },
          {
            name: '大盛镇',
            value: 2500
          },
		  {
		    name: '石埠子镇',
		    value: 2000
		  },
		  {
		    name: '石堆镇',
		    value: 1500
		  },
		  {
		    name: '拓山镇',
		    value: 1000
		  },
		  {
		    name: '辉渠镇',
		    value: 500
		  },
		  {
		    name: '吾山镇',
		    value: 250
		  },
		  {
		    name: '金冢子镇',
		    value: 200
		  },
        ]
      }
    }
  },
  components: {  }
}
</script>

<style lang="scss" scoped>
#centerRight2 {
  $box-height: 410px;
  $box-width: 340px;
  padding: 5px;
  height: 500px;
  width: 99%;
  border-radius: 5px;
  .bg-color-black {
    padding: 5px;
    height: 500px;
    width: 98%;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 10px;
    overflow: hidden;
    .dv-cap-chart {
      width: 100%;
      height: 450px;
    }
  }
}
</style>
